function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20.9004 41.973C32.3603 41.973 41.6504 32.6829 41.6504 21.223C41.6504 9.76309 32.3603 0.473 20.9004 0.473C9.44048 0.473 0.150391 9.76309 0.150391 21.223C0.150391 32.6829 9.44048 41.973 20.9004 41.973Z",
  fill: "#5BC0CE"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M29.6116 21.2224C29.6118 21.2226 29.6119 21.2228 29.6121 21.223C29.6119 21.2232 29.6118 21.2234 29.6116 21.2236C29.4975 21.3937 29.3258 21.6391 29.0995 21.9347C28.6464 22.5266 27.977 23.3157 27.1137 24.1037C25.3807 25.6855 22.9113 27.223 19.8682 27.223C16.7574 27.223 14.2569 25.6829 12.5114 24.1024C11.6413 23.3146 10.9692 22.5257 10.515 21.9342C10.2882 21.6387 10.1165 21.3935 10.0024 21.2236C10.0023 21.2234 10.0022 21.2232 10.002 21.223C10.0022 21.2228 10.0023 21.2227 10.0024 21.2225C10.1165 21.0525 10.2882 20.8073 10.515 20.5119C10.9692 19.9203 11.6413 19.1315 12.5114 18.3437C14.2569 16.7631 16.7574 15.223 19.8682 15.223C22.9113 15.223 25.3807 16.7605 27.1137 18.3423C27.977 19.1303 28.6464 19.9195 29.0995 20.5113C29.3258 20.8069 29.4975 21.0523 29.6116 21.2224Z",
  stroke: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M19.8074 24.06C21.4191 24.06 22.7256 22.7535 22.7256 21.1418C22.7256 19.5301 21.4191 18.2236 19.8074 18.2236C18.1957 18.2236 16.8892 19.5301 16.8892 21.1418C16.8892 22.7535 18.1957 24.06 19.8074 24.06Z",
  stroke: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M27.6631 33.0168C30.39 33.0168 32.6006 30.8062 32.6006 28.0793C32.6006 25.3524 30.39 23.1418 27.6631 23.1418C24.9362 23.1418 22.7256 25.3524 22.7256 28.0793C22.7256 30.8062 24.9362 33.0168 27.6631 33.0168Z",
  fill: "#5BC0CE",
  stroke: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M27.913 27.8038C29.0107 27.8038 30.0965 28.5932 30.0965 29.7548V30.6073C30.0965 30.6504 30.0605 30.6864 30.0166 30.6864H25.8086C25.7654 30.6864 25.7295 30.6504 25.7295 30.6073V29.7548C25.7295 28.5932 26.8152 27.8038 27.913 27.8038Z",
  stroke: "#FEFEFE"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M27.8482 25.097C28.5497 25.097 29.1193 25.6667 29.1193 26.3681C29.1193 27.0704 28.5497 27.6392 27.8482 27.6392C27.146 27.6392 26.5771 27.0704 26.5771 26.3681C26.5771 25.6667 27.1468 25.097 27.8482 25.097Z",
  stroke: "#FEFEFE"
});

var SvgVoluntaryVision = function SvgVoluntaryVision(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVoluntaryVision, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/voluntaryVision.de6f37ba.svg";
export { ForwardRef as ReactComponent };